module.exports = __webpack_public_path__ + "static/media/pizza_icon.87acd76e.svg";